import * as React from "react";
import { Descriptions } from "antd";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { IInstitutionDetails } from "../../../organisations/model/InstitutionDetails";

const InstitutionDetailsSidebar = ({
  translate,
  institutionDetails
}: {
  translate: TTranslate;
  institutionDetails: IInstitutionDetails;
}) => {
  return (
    <div className={"dashboard-sider-block"}>
      <Descriptions
        size={"small"}
        layout="horizontal"
        bordered
        colon={false}
        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
      >
        {institutionDetails.institutionType && (
          <Descriptions.Item
            label={translate(
              "editors.organisations.institution_details.institution_type"
            )}
          >
            <strong>{institutionDetails.institutionType}</strong>
          </Descriptions.Item>
        )}
        {institutionDetails.headquartersName && (
          <Descriptions.Item
            label={translate(
              "editors.organisations.institution_details.headquarters_name"
            )}
          >
            <strong>{institutionDetails.headquartersName}</strong>
          </Descriptions.Item>
        )}
        {institutionDetails.jurisdictionName && (
          <Descriptions.Item
            label={translate(
              "editors.organisations.institution_details.jurisdiction_name"
            )}
          >
            <strong>{institutionDetails.jurisdictionName}</strong>
          </Descriptions.Item>
        )}
        {institutionDetails.jurisdictionType && (
          <Descriptions.Item
            label={translate(
              "editors.organisations.institution_details.jurisdiction_type"
            )}
          >
            <strong>{institutionDetails.jurisdictionType}</strong>
          </Descriptions.Item>
        )}
      </Descriptions>
    </div>
  );
};
export default InstitutionDetailsSidebar;
